import React from 'react';
import clsx from 'clsx';
import Location from '@/models/location';
import CustomImage from '@/components/CustomImage/CustomImage';
import {
  getCreateLinkCategoryLabel,
  getCreateLinkPlaceCity,
  getCreateLinkPlacePhoto,
} from './createNewLinkUtils';
import { CREATE_LINK_COPY } from './createNewLinkCopy';

interface CreateNewLinkPlaceCardProps {
  location: Location;
  showLiveBadge?: boolean;
  compact?: boolean;
  className?: string;
}

const CreateNewLinkPlaceCard: React.FC<CreateNewLinkPlaceCardProps> = ({
  location,
  showLiveBadge = false,
  compact = false,
  className,
}) => {
  const photo = getCreateLinkPlacePhoto(location);
  const city = getCreateLinkPlaceCity(location);
  const categoryLabel = getCreateLinkCategoryLabel(location);

  return (
    <div
      className={clsx(
        'flex min-w-0 items-center gap-3 rounded-card border border-gray-200 bg-white',
        compact ? 'p-3' : 'p-4',
        className,
      )}
    >
      <div
        className={clsx(
          'relative shrink-0 overflow-hidden rounded-tag bg-gray-100',
          compact ? 'size-14' : 'size-16',
        )}
      >
        <CustomImage
          src={photo}
          alt=""
          fill
          className="object-cover"
          sizes={compact ? '56px' : '64px'}
        />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <p className="truncate font-manrope text-body font-semibold leading-5 tracking-body text-gray-900">
            {location.name || 'Place'}
          </p>
          {showLiveBadge ? (
            <span className="rounded-tag bg-green-honeydew px-2 py-0.5 font-manrope text-footnote font-semibold tracking-label text-green-earned">
              {CREATE_LINK_COPY.liveBadge}
            </span>
          ) : null}
        </div>
        <p className="mt-0.5 truncate font-manrope text-footnote text-gray-500">{city}</p>
        {categoryLabel ? (
          <span className="mt-1.5 inline-flex rounded-tag border border-gray-200 px-2 py-0.5 font-manrope text-footnote font-semibold uppercase tracking-label text-gray-700">
            {categoryLabel}
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default CreateNewLinkPlaceCard;
